import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
  current: null,
  loading: false,
  error: null,
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  },
  filters: {},
  sort: {
    field: 'stock_issues.created_at',
    direction: 'desc'
  },
  settings: null,
  isSettingsInitialized: false,
  
  filterLoading: false,
  isDefaultFilter: false,
  defaultFilter: {
    id: '',
    name: '',
    identifier: '',
    user_id: '',
    is_shared: false,
    is_readonly: false,
    save_filter: false,
    mark_default: false,
    rules: {
        condition: "and",
        children: []
    } 
  }
};

const dailyproductionSlice = createSlice({
  name: 'dailyproduction',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setList: (state, action) => {
      state.list = action.payload.data || [];
      state.pagination = {
        current_page: action?.payload?.meta?.current_page || 1,
        per_page: action?.payload?.meta?.per_page || 10,
        // no meta.total = count deferred (fetched separately); estimate so Next stays usable
                total: action?.payload?.meta?.total
                    ?? ((action?.payload?.meta?.current_page || 1) * (action?.payload?.meta?.per_page || 10) + (action?.payload?.links?.next ? 1 : 0)),
        last_page: action?.payload?.meta?.last_page || 1
      };
      state.loading = false;
      state.error = null;
    },
    setCurrent: (state, action) => {
      state.current = action.payload;
      state.loading = false;
      state.error = null;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setSettings: (state, action) => {
      state.settings = action.payload;
      state.isSettingsInitialized = true;
      // Apply settings to pagination and sort if they exist
      if (action.payload?.per_page) {
        state.pagination.per_page = action.payload.per_page;
      }
      if (action.payload?.default_sort_field) {
        state.sort.field = action.payload.default_sort_field;
      }
      if (action.payload?.default_sort_direction) {
        state.sort.direction = action.payload.default_sort_direction;
      }
    },
    setDefaultFilter: (state, action) => {
      state.defaultFilter = action.payload;
    },
    setFilterLoading: (state, action) => {
      state.filterLoading = action.payload;
    },
    changeFilterCondition: (state, action) => {
      state.defaultFilter = {
        ...state.defaultFilter,
        rules: {
          ...state.defaultFilter.rules,
          condition: action.payload
        }
      };
    },
    addFilterCondition: (state, action) => {
      state.defaultFilter = {
        ...state.defaultFilter,
        rules: {
          ...state.defaultFilter.rules,
          children: [
            ...state.defaultFilter.rules.children,
            action.payload
          ]
        }
      };
    },
    updateFilterConditionRule: (state, action) => {
      const updatedChildren = state.defaultFilter.rules.children.map((child, idx) => 
        idx === action.payload.index ? { ...child, query: { ...child.query, ...action.payload.data } } : child
      );
      state.defaultFilter = {
        ...state.defaultFilter,
        rules: {
          ...state.defaultFilter.rules,
          children: updatedChildren
        }
      };
    },
    updateFilterConditionValue: (state, action) => {
      const updatedChildren = state.defaultFilter.rules.children.map((child, idx) => 
        idx === action.payload.index ? { ...child, query: { ...child.query, value: action.payload.value } } : child
      );
      state.defaultFilter = {
        ...state.defaultFilter,
        rules: {
          ...state.defaultFilter.rules,
          children: updatedChildren
        }
      };
    },
    removeFilterCondition: (state, action) => {
      const filteredChildren = state.defaultFilter.rules.children.filter((_, idx) => 
        idx !== action.payload
      );
      state.defaultFilter = {
        ...state.defaultFilter,
        rules: {
          ...state.defaultFilter.rules,
          children: filteredChildren
        }
      };
    },
    clearCurrent: (state) => {
      state.current = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetFiltersAndPagination: (state) => {
      state.pagination = {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
      };
      state.sort = {
        field: 'stock_issues.created_at',
        direction: 'desc'
      };
      state.filters = {};
    },
    setSelected: (state, action) => {
      state.settings = {
        ...state.settings,
        selected: {
          ...state.settings.selected,
          [action.payload.key]: action.payload.data
        }
      };
    }
  }
});

export const {
  setLoading: setDailyProductionLoading,
  setError: setDailyProductionError,
  setList: setDailyProductionList,
  setCurrent: setDailyProductionCurrent,
  setSort: setDailyProductionSort,
  setPagination: setDailyProductionPagination,
  setSettings: setDailyProductionSettings,
  setFilters: setDailyProductionFilters,
  setDefaultFilter: setDailyProductionDefaultFilter,
  setFilterLoading: setDailyProductionFilterLoading,
  
  changeFilterCondition: changeDailyProductionFilterCondition,
  addFilterCondition: addDailyProductionFilterCondition,
  updateFilterConditionRule: updateDailyProductionFilterConditionRule,
  updateFilterConditionValue: updateDailyProductionFilterConditionValue,
  removeFilterCondition: removeDailyProductionFilterCondition,
  clearCurrent: clearDailyProductionCurrent,
  clearError: clearDailyProductionError,
  setSelected: setDailyProductionSelected,
  resetFiltersAndPagination: resetDailyProductionFiltersAndPagination
} = dailyproductionSlice.actions;

export default dailyproductionSlice.reducer; 